var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89032 18.8918L0.836101 20.0152L1.95947 14.961C1.21966 13.5772 0.833738 12.0318 0.836101 10.4627C0.836101 5.18686 5.11275 0.910217 10.3886 0.910217C15.6644 0.910217 19.9411 5.18686 19.9411 10.4627C19.9411 15.7385 15.6644 20.0152 10.3886 20.0152C8.81945 20.0175 7.27411 19.6316 5.89032 18.8918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorCommentIcon);
export default __webpack_public_path__ + "static/media/VectorCommentIcon.e444fa9b2e80a3994391449282444bbb.svg";
export { ForwardRef as ReactComponent };